import Labels from "../Data.Labels/Labels";
import { StorageTypeEnum, HistoryStorageMethodEnum, BuiltInType } from '@iconics/providers.fadx-platform-api-client-v2'

export class StaticDataProvider implements IStaticDataProvider
{
    private labels: Labels;

    constructor(labels: Labels)
    {
        this.labels = labels;
    }

    public getStorageTypes(): IStorageType[]
    {
        return [
            { id: 'Cosmos', name: this.labels.Entity_StorageType_Cosmos },
            { id: 'SQL', name: this.labels.Entity_StorageType_SQL },
            { id: 'ADT', name: this.labels.Entity_StorageType_ADT },
        ];
    }

    public getHistoryStorageMethods(): IHistoryStorageMethod[]
    {
        return [
            { id: 'None', name: this.labels.Entity_HistoryStorageMethod_None },
            { id: 'CosmosFullHistory', name: this.labels.Entity_HistoryStorageMethod_CosmosFullHistory },
            { id: 'CosmosSingleRecordHistory', name: this.labels.Entity_HistoryStorageMethod_CosmosSingleRecordHistory },
            { id: 'Audit', name: this.labels.Entity_HistoryStorageMethod_Audit },
        ];
    }

    public getBuiltInTypes(): IBuiltInType[]
    {
        return [
            { id: 'Void', name: 'Void' },
            { id: 'Char', name: 'Char' },
            { id: 'Int16', name: 'Int16' },
            { id: 'Int32', name: 'Int32' },
            { id: 'Int64', name: 'Int64' },
            { id: 'Byte', name: 'Byte' },
            { id: 'UInt16', name: 'UInt16' },
            { id: 'UInt32', name: 'UInt32' },
            { id: 'UInt64', name: 'UInt64' },
            { id: 'Single', name: 'Single' },
            { id: 'Double', name: 'Double' },
            { id: 'Boolean', name: 'Boolean' },
            { id: 'String', name: 'String' },
            { id: 'TypeInfo', name: 'TypeInfo' },
            { id: 'Status', name: 'Status' },
            { id: 'DateTime', name: 'DateTime' },
            { id: 'Guid', name: 'Guid' },
            { id: 'SByte', name: 'SByte' },
            { id: 'Decimal', name: 'Decimal' },
            { id: 'TimeSpan', name: 'TimeSpan' },
        ];
    }

    public getSyncTypes(): ISyncType[]
    {
        return [
            { id: 'None', name: this.labels.IdentityProviders_SyncType_None },
            { id: 'GraphAPI', name: this.labels.IdentityProviders_SyncType_GraphAPI },
            { id: 'SCIMv2', name: this.labels.IdentityProviders_SyncType_SCIMv2 },
            { id: 'GroupsClaimSync', name: this.labels.IdentityProviders_SyncType_GroupsClaimSync },
        ];
    }

    public getSyncTypesBySecurityProvider(providerId: number): ISyncType[]
    {
        const syncTypeIds = this.getSecurityProviderSyncTypes().filter(i => i.securityProviderId == providerId).map(i => i.syncTypeId);
        const syncTypes = this.getSyncTypes().filter(i => syncTypeIds.includes(i.id));
        return syncTypes;

    }

    public getSecurityProviders(): ISecurityProvider[]
    {
        return [
            { id: SecurityProviderId_Native, name: this.labels.IdentityProvider_SecurityProviderTypeId_Native },
            { id: SecurityProviderId_Aad, name: this.labels.IdentityProvider_SecurityProviderTypeId_AAD },
            { id: SecurityProviderId_B2C, name: this.labels.IdentityProvider_SecurityProviderTypeId_B2C },
            { id: SecurityProviderId_Okta, name: this.labels.IdentityProvider_SecurityProviderTypeId_Okta },
            { id: SecurityProviderId_Auth0, name: this.labels.IdentityProvider_SecurityProviderTypeId_Auth0 },
        ];
    }

    public getSecurityProviderSyncTypes(): ISecurityProviderSyncType[]
    {
        return [
            { securityProviderId: SecurityProviderId_Native, syncTypeId: 'None' },

            { securityProviderId: SecurityProviderId_Aad, syncTypeId: 'None' },
            { securityProviderId: SecurityProviderId_Aad, syncTypeId: 'GraphAPI' },
            { securityProviderId: SecurityProviderId_Aad, syncTypeId: 'SCIMv2' },

            { securityProviderId: SecurityProviderId_Okta, syncTypeId: 'None' },
            { securityProviderId: SecurityProviderId_Okta, syncTypeId: 'SCIMv2' },
            { securityProviderId: SecurityProviderId_Okta, syncTypeId: 'GroupsClaimSync' },

            { securityProviderId: SecurityProviderId_Auth0, syncTypeId: 'None' },
            { securityProviderId: SecurityProviderId_Auth0, syncTypeId: 'GroupsClaimSync' },

            { securityProviderId: SecurityProviderId_B2C, syncTypeId: 'None' },
            { securityProviderId: SecurityProviderId_B2C, syncTypeId: 'GraphAPI' },
            { securityProviderId: SecurityProviderId_B2C, syncTypeId: 'GroupsClaimSync' },
        ];
    }
}

export interface IStaticDataProvider
{
    getStorageTypes(): IStorageType[];
    getHistoryStorageMethods(): IHistoryStorageMethod[];
    getBuiltInTypes(): IBuiltInType[];
    getSyncTypes(): ISyncType[];
    getSyncTypesBySecurityProvider(providerId: number): ISyncType[];
    getSecurityProviders(): ISecurityProvider[];
    getSecurityProviderSyncTypes(): ISecurityProviderSyncType[];
}

export interface IStorageType
{
    id: StorageTypeEnum;
    name: string;
}

export interface IHistoryStorageMethod
{
    id: HistoryStorageMethodEnum;
    name: string;
}

export interface IBuiltInType
{
    id: BuiltInType;
    name: string;
}

export interface ISyncType
{
    id: SyncronisationType;
    name: string;
}

export type SyncronisationType = 'None' | 'GraphAPI' | 'SCIMv2' | 'GroupsClaimSync';

export interface ISecurityProvider
{
    id: SecurityProviderId;
    name: string;
}

export type SecurityProviderId = 0 | 1 | 2 | 3 | 4;

export const SecurityProviderId_Native = 0;
export const SecurityProviderId_Aad = 1;
export const SecurityProviderId_Okta = 2;
export const SecurityProviderId_Auth0 = 3;
export const SecurityProviderId_B2C = 4;

export interface ISecurityProviderSyncType
{
    securityProviderId: SecurityProviderId;
    syncTypeId: SyncronisationType;
}

export type UserType = 'User' | 'App';

export const RootNodeId = 1;
